module.exports = __webpack_public_path__ + "static/media/circle-cinema.74500a97.svg";